import './mediaEmbed.html.twig';
import './mediaEmbed.css';

export default function() {
  const el = document.querySelectorAll('.media-embed');
  if (!el) {
    return;
  }

  el.forEach(media => {
    const iframe = media.querySelector('iframe');
    if (iframe) {
      media.classList.add('media-embed--iframe');
    }
  });
}
